import { fonts } from '@local/web-design-system/styles';
import type { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

// Use darkTheme primary from https://marvelapp.com/prototype/j8fj4a7/screen/90729204
const LINK_HOVER_COLOR = '#007cb5';

export const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        backgroundColor: theme.palette.grey[900],
        height: '100%',
        padding: theme.spacing(6),
        overflow: 'auto',
    },
    logo: {
        width: '100%',
        height: '0',
        paddingLeft: theme.spacing(2),
    },
    body: {
        padding: theme.spacing(2),
        fontFamily: fonts.fontFamily,
        height: '90%',
        fontWeight: fonts.weights.regular,
        h1: {
            color: theme.palette.grey[50],
            fontSize: '18px',
            marginBottom: theme.spacing(3),
            marginTop: theme.spacing(3),
            borderBottom: `1px solid ${theme.palette.grey[200]}40`,
        },
        a: {
            '&:hover': {
                color: LINK_HOVER_COLOR,
            },
        },
        '& p, a': {
            color: theme.palette.grey[400],
            fontSize: '13px',
            lineSpacing: '19px',
        },
    },
}));
